import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

const productInvestigationRootRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'product-investigation-root',
});

export const BY_IDS_TAB = 'by-ids';
export const BY_NAME_TAB = 'by-name';

export const productInvestigationRoute = createRoute({
  getParentRoute: () => productInvestigationRootRoute,
  path: '/product-investigation',
  component: lazyRouteComponent(() => import('./ProductInvestigationView')),
  validateSearch: z.object({
    productId: z.string().optional(),
    warehouseId: z.string().optional(),
    investigateItem: z.boolean().optional(),
    showItemInfoDrawer: z.boolean().optional(),
    tab: z.enum([BY_IDS_TAB, BY_NAME_TAB]).optional(),
  }).parse,
});

export const productInvestigationRouteTree = productInvestigationRootRoute.addChildren([
  productInvestigationRoute,
]);
